import './scss/components/exit-popup.scss';
import { initExitPopup } from './js/front/components/exit-popup';

document.addEventListener( 'DOMContentLoaded', initExitPopup );
